// 由於 Object.fromEntries() 屬於 ES10 語法，未兼容較低版本瀏覽器，因此先改用土法煉鋼法
/** 一般物件（排除 null 與陣列）；巢狀 config / meta 走訪的共用判準 */
export const isPlainObject = value =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const fromEntries = (parseArray = []) => {
    let obj = {};
    for (let [key, value] of parseArray) {
        obj[key] = value;
    }
    return obj;
};
